import { initializeApp } from "firebase/app";
import { getAuth, GithubAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBW4HJsD2w4hDVEv0fVp9Q1ip2NEP76X7I",
  authDomain: "authredux-71e24.firebaseapp.com",
  projectId: "authredux-71e24",
  storageBucket: "authredux-71e24.firebasestorage.app",
  messagingSenderId: "265312777045",
  appId: "1:265312777045:web:b36023ac6fb422e043b5dc",
  measurementId: "G-3KZYXS4VZ4",
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

const github = new GithubAuthProvider();
export { auth, github };
